import { useEffect } from 'react';

let depth = 0;

function syncPhoneOverlayLock() {
  document.body.classList.toggle('phone-overlay-open', depth > 0);
  document.body.dataset.phoneOverlayDepth = String(depth);
}

/** Hide the phone shortcut bar while a sheet, modal, or drawer is open. */
export function acquirePhoneOverlayLock(): () => void {
  depth += 1;
  syncPhoneOverlayLock();
  let released = false;
  return () => {
    if (released) return;
    released = true;
    depth = Math.max(0, depth - 1);
    syncPhoneOverlayLock();
  };
}

export function usePhoneOverlayLock(active: boolean): void {
  useEffect(() => {
    if (!active) return;
    return acquirePhoneOverlayLock();
  }, [active]);
}
